export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(960)]: { display: "flex" },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(960)]: { display: "flex" },
  },
  root: {
    padding: 30,
    minHeight: "50vh",
  },
  tablerow: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.3,
    },
  },
  loader: {
    padding: 20,
    minHeight: "50vh",
    display: "flex",
    flexDirection: "column",
    fontSize: 24,
    justifyContent: "center",
    alignItems: "center",
  },
  buttonStyle: {
    variant: "outlined",
    backgroundColor: "green !important",
    outlineColor: "green !important",
    color: "#fff",
    textTransform: "none",
  },
});
